module.exports = __webpack_public_path__ + "img/gradient-map_en.a28a969.jpg";